module.exports = __webpack_public_path__ + "static/media/Home-X-02.bec3db5d.png";